/**
 * Daily Pulse Lesson
 * Skill Area: Foundations
 * Focus your day with strategic prioritization
 */

import type { LessonDefinition } from '../types';
import {
  DAILY_PULSE_AI_PROMPT,
  DAILY_PULSE_CONTEXT_SCENARIOS,
} from '../prompts/daily-pulse.prompt';

export const dailyPulse: LessonDefinition = {
  id: 'daily-pulse',
  title: 'Daily Pulse',
  displayTitle: 'Focus Your Day with Strategic Prioritization',
  subTitle: "Name today's win and invite Lyra.",
  tagline: "Choose today's win and how Lyra can back you up.",
  persona: 'Lyra',
  skillArea: 'Foundations',
  format: 'guided_chat',
  difficulty: 'Beginner',
  estimatedMinutes: 5,
  tags: ['streak', 'focus', 'confidence'],
  dailyEligible: true,
  releasedAt: '2025-01-15T00:00:00.000Z',
  route: '/micro/lyra-daily-pulse',
  storyBeat: 'Lyra helps you focus on one doable move.',
  contextTitle: 'What to drop in',
  contextSummary:
    'Think about where the day can tilt. Borrow one of these setups if you\'re blank and let Lyra steady the plan.',
  contextScenarios: DAILY_PULSE_CONTEXT_SCENARIOS,
  introPrompt:
    "A scattered day drains your energy. I'll explain why focused prioritization matters, show you a comparison, and then we'll build your plan.",
  steps: [
    'Select your current state (Scramble, High Stakes, or Drift)',
    'See a "Reactive vs. Focused" comparison',
    'Build your Win/Drift/Assist plan',
  ],
  promptGuidance: 'Choose a mode below or type your own.',
  aiPrompt: DAILY_PULSE_AI_PROMPT,
  inputPlaceholder: "Type 'Morning Scramble' or your own mode...",
  quickPrompts: ['Morning Scramble', 'High Stakes', 'Focus Drift'],
};
